
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Button, Grid, MenuItem, TextField } from "@mui/material"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useUsuariosStore, useVehiculoStore } from "../../../../store";




export const FormCreateUpdateVehiculo = ({ initialState }) => {


    const { id } = useParams();
    const { startCreateVehiculo } = useVehiculoStore();
    const { startListSegunRol, usuarios } = useUsuariosStore()
    

    useEffect(() => {
        startListSegunRol('CONDUCTOR')
    }, []);
    

    const [formUser, setFormUser] = useState( initialState );
    const  { placa, modelo, conductor, soatInicio, tecnoInicio, todoRiesgoInicio } = formUser;
    const handleInputChange = ({ target }) => {
        setFormUser({
            ...formUser,
            [target.name]: target.value
        });
    }


    const handleChangeStart = (e) => {
        setFormUser({ ...formUser, soatInicio: e.$d});
    }


    const handleChangeStartRiesgo = (e) => {
        setFormUser({ ...formUser, todoRiesgoInicio: e.$d });
    }


    const handleChangeTecStart = (e) => {
        setFormUser({ ...formUser, tecnoInicio: e.$d });
    }



    const handleCrearUsuario = async(e) => {
        e.preventDefault();
        if( [placa, modelo, conductor].includes('') ){
            return console.log('Formulario Incorrecto');
        }
        const resp = await startCreateVehiculo({ ...formUser, id });
        if(resp && !id){
            setFormUser(initialState);
        }
    }


    return (

        <form onSubmit={ handleCrearUsuario } >
            <Grid container spacing={ 2 }>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Placas'
                        type='text'
                        placeholder='Placas'
                        fullWidth
                        name='placa'
                        value={ placa }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Modelo'
                        type='text'
                        placeholder='Modelo'
                        fullWidth
                        name='modelo'
                        value={ modelo }
                        onChange={ handleInputChange }
                    />
                </Grid>

                {(usuarios.length > 0) &&
                <Grid item xs={ 12 } sm={ 6 }>
                    <TextField required
                        select
                        label="Seleccione Conductor"
                        fullWidth
                        name='conductor'
                        value={conductor}
                        onChange={ handleInputChange }
                    >
                        <MenuItem value=''> Seleccione Conductor</MenuItem>
                        {usuarios?.map( e => (
                            <MenuItem key={ e.id } value={ e.id } >{ e.nombre }</MenuItem>
                        ))}
                    </TextField>
                </Grid>
                }

                <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Soat Inicio"
                            value={ soatInicio }
                            onChange={ handleChangeStart }
                            renderInput={ (params) => <TextField {...params} fullWidth /> }
                        />
                    </LocalizationProvider>
                </Grid>


                <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Tecnomecanica Inicio"
                            value={tecnoInicio}
                            onChange={handleChangeTecStart}
                            renderInput={ (params) => <TextField {...params} fullWidth /> }
                        />
                    </LocalizationProvider>
                </Grid>


                <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Todo Riesgo Inicio"
                            value={ todoRiesgoInicio }
                            onChange={ handleChangeStartRiesgo }
                            renderInput={ (params) => <TextField {...params} fullWidth /> }
                        />
                    </LocalizationProvider>
                </Grid>
            </Grid>

            <Grid container sx={{mt:4, mb:2}} direccion='column'justifyContent='center'>
                <Grid item xs={12} sm={8} md={6}>
                    <Button variant='contained' fullWidth type='submit'>
                        {(id) ? 'Actualizar Vehiculo' : 'Crear Vehiculo'}
                    </Button>
                </Grid>
            </Grid> 
        </form>
    )
}
